module.exports = __webpack_public_path__ + "static/media/flayer.373ca945.jpg";